/* global jQuery, ga4Obj */

import GA4Tracking from './utils/ga4-tracking'

export const handleOnClickSelectItemEvent = () => {
  jQuery(document).on('click', (e) => {
    const element = jQuery(e.target)
    const gaItemElement = element.is('[data-ga-item]') ? element : element.closest('[data-ga-item]')
    const gaDataElement = gaItemElement.closest('[data-ga-data]') ?? null
    if (gaItemElement.length === 0 || gaDataElement.length === 0) {
      return
    }

    let gaItem = gaItemElement.attr('data-ga-item')
    gaItem = gaItem !== null ? JSON.parse(gaItem) : null
    if (typeof gaItem !== 'object') {
      return
    }

    let gaData = gaDataElement.length > 0 ? gaDataElement.attr('data-ga-data') : null
    gaData = gaData !== null ? JSON.parse(gaData) : null
    if (typeof gaData !== 'object') {
      return
    }

    gaData.item_list_id = 'select-item__' + gaData?.item_list_id
    gaData.item_list_name = ga4Obj.types.select_item + ': ' + gaData?.item_list_name

    GA4Tracking.pushEvent('select_item', [gaItem], gaData)
  })
}
